module.exports = __webpack_public_path__ + "static/media/backup.9c88b6b6.gif";